<template>
  <div class="add-box">
    <h4 style="font-size: 14px; margin-bottom: 20px; color: #000000; font-weight: bold">
      疾病类别：
    </h4>
    <el-radio-group v-model="diseaseCode">
      <el-radio
        v-for="(item, index) in diseaseType"
        :key="index"
        border
        :label="item.code"
      >
        {{ item.name }}
      </el-radio>
    </el-radio-group>

    <div style="margin: 5px 0px">
      <ul class="select-option" style="overflow: hidden; margin-bottom: 0px">
        <li>
          <span class="select-title">部位：</span>
          <el-cascader
            v-model="diagnosisCode"
            :show-all-levels="false"
            :options="diseaseList"
            :props="diseaseProps"
            placeholder="疾病名称"
            clearable
            @change="diseaseChange"
          />
        </li>
        <li>
          <span class="select-title">程度：</span>
          <el-input
            v-model="degree"
            placeholder="请输入程度"
            class="select-input"
            @keyup.enter.native="search"
          />
        </li>
        <li>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </li>
      </ul>
      <el-table border :data="tableData" style="width: 100%" tooltip-effect="dark">
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column label="部位" prop="partsName" align="center" />
        <el-table-column label="器官" prop="organName" align="center" />
        <el-table-column label="诊断" prop="diagnosisName" align="center" />
        <el-table-column label="程度" prop="degreeName" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      diseaseType: [],
      diseaseList: null,
      diseaseProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },
      diseaseName: '',
      diseaseCode: 100001,
      diagnosisCode: '',
      degree: '',
      tableData: [],
      loading: true
    }
  },

  watch: {
    diseaseCode() {
      this.getselectdiseaseList()
    }
  },

  created() {
    this.$emit('setCurrentMenu', '疾病库')
    this.getdiseaseTypeList()
    this.getdiseaseList()
    this.getselectdiseaseList()
  },

  methods: {
    /**
     * 疾病类别
     */
    getdiseaseTypeList() {
      this.axios
        .get(this.homePath() + '/disease-library/list-all')
        .then((res) => {
          this.diseaseType = res.data
        })
        .catch((error) => console.log(error))
    },

    getdiseaseList() {
      // 疾病名称
      const vm = this
      vm.axios
        .get(vm.homePath() + '/organ-parts-diagnosis/list')
        .then((res) => {
          if (res.data.status == '000000') {
            const data = res.data.data
            vm.diseaseList = vm.filterNull(vm.toTreeData(data, 'parentCode', 'code'))
          } else {
            vm.$alert(res.data.message, '提示', {
              callback: (action) => {
                vm.$router.push('/index/allcase')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    getselectdiseaseList() {
      const vm = this
      vm.axios
        .get(
          vm.homePath() +
            '/disease/select-disease?libraryCode=' +
            vm.diseaseCode +
            '&diagnosisCode=' +
            vm.diagnosisCode +
            '&degree=' +
            vm.degree
        )
        .then((res) => {
          vm.loading = false
          const data = res.data
          vm.tableData = data
        })
        .catch((error) => console.log(error))
    },

    diseaseChange(val) {
      if (val != null) {
        this.diagnosisCode = val
      }
    },

    search() {
      this.getselectdiseaseList()
    }
  }
}
</script>

<style></style>
